import loadable from '@loadable/component';

export const ComparisonNotificationLoadableContainer = loadable(() => import('./ComparisonNotificationContainer'));
